<template>
  <component
    :is="componentTag"
    class="button"
    :class="modifiers"
    v-bind="attributes"
    v-on="$listeners"
  >
    <BaseSpinner v-if="isLoading" />
    <slot v-else>
      {{ text }}
    </slot>
  </component>
</template>

<script>
import BaseLink from '@/components/BaseLink.vue';
import BaseSpinner from '@/components/BaseSpinner.vue';

export default {
  name: 'BaseButton',
  components: {
    BaseSpinner,
  },
  props: {
    tag: {
      type: String,
      default: 'button',
    },
    href: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    isBorder: {
      type: Boolean,
      default: false,
    },
    isBright: {
      type: Boolean,
      default: false,
    },
    isDim: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    componentTag() {
      if (this.href && !this.$attrs.disabled) return BaseLink;
      return this.tag;
    },
    attributes() {
      const attributes = {};
      if (this.href && !this.$attrs.disabled) {
        attributes.href = this.href;
      }
      if (this.componentTag === 'button') {
        attributes.type = 'button';
      }
      return { ...attributes, ...this.$attrs };
    },
    modifiers() {
      const modifiers = {
        button_border: this.isBorder,
        button_bright: this.isBright,
        button_dim: this.isDim,
      };
      if (this.size) modifiers[`button_size_${this.size}`] = true;
      return modifiers;
    },
  },
};
</script>

<style lang="stylus">
.button
  display inline-flex
  align-items center
  justify-content center
  vertical-align top
  font-family inherit
  text-decoration none
  font-size 0.85em
  text-align center
  font-weight 400
  letter-spacing .02em
  line-height 1
  max-width 100%
  height 3.2em
  background #50B2FF
  color #fff
  padding 0 1.5em
  margin 0
  border 0
  outline none
  border-radius 0.4em
  &:hover
  &:active
    background-color #2B95E8

  &_border
    color $c_bright
    background-color #fff
    border solid 1px currentColor
    &:hover
      background-color @color
      border-color @color
      color #fff

  &_bright
    background-color #567DF4
    color #fff
    &:hover
      background-color #4064D4

  &_dim
    background-color #EBEFFB
    color #567DF4
    &:hover
      background-color #D5DEFB

  &[disabled]
    background-color #DFDFDF
    color #fff

  &_size_s
    font-size 0.75em

  &__icon
    height 1em
    margin-right 0.8em
    &_after
      margin-left 0.8em
      margin-right 0
</style>
